<template>
  <iframe
    v-if="showPdf"
    width="100%"
    style="height: calc(100vh - 7px);"
    :src="'/pdfjs/web/viewerWithDownloadAndPrint.html?file=' + contentPrimary"
    id="viewer"
  />
  <div class="white-bg" v-else-if="act">
    <div id="reg_page_body" class="page-body">
      <nav
        id="actTitleNavbar"
        class="navbar navbar-default"
        style="margin-bottom:0;"
      >
        <div id="actTitleHeader" class="navbar-header">
          <div
            class="navbar-text"
            id="actTitle"
            style="display: flex; justify-content: center; align-items: center;"
          >
            <button
              type="button"
              class="navbar-toggle pull-left expand-tabs-sm"
              style="margin-left: 8px;"
              @click="showRefDiv()"
            >
              <span class="fa fa-bars"></span>
            </button>
            {{ act.actTitle }}
          </div>
        </div>
      </nav>
      <div class="row theme-green main-panel">
        <div class="flex-div">
          <div
            class="col-lg-offset-2 col-xl-8 col-md-offset-0 col-lg-10 col-md-12 col-sm-offset-0 col-xs-offset-0 col-sm-12 col-xs-12"
            style="height: 100%; padding: 0;"
          >
            <div id="searchBarPrimary">
              <div class="input-group">
                <span class="input-group- left-search">
                  <button
                    class="btn btn-default"
                    tooltips=""
                    tooltip-append-to-body="true"
                    tooltip-side="bottom"
                    tooltip-class="tooltip-klass"
                    title="Штампа"
                    @click="onPrintClick(act.ogNumberDescription)"
                  >
                    <span class="fa fa-print"></span>
                  </button>
                  <button
                    tooltips=""
                    tooltip-append-to-body="true"
                    tooltip-side="bottom"
                    tooltip-class="tooltip-klass"
                    title="Експорт у WORD"
                    class="btn btn-default"
                    @click="onExportAct()"
                  >
                    <span class="fa fa-file-word"></span>
                  </button>
                  <button
                    tooltips=""
                    tooltip-append-to-body="true"
                    tooltip-side="bottom"
                    tooltip-class="tooltip-klass"
                    title="Отвори само текст акта"
                    class="btn btn-default"
                    @click="onExportHtml(act.contentUrl)"
                  >
                    <span class="fa fa-external-link"></span>
                  </button>
                  <button
                    tooltips=""
                    tooltip-append-to-body="true"
                    tooltip-side="bottom"
                    tooltip-class="tooltip-klass"
                    title="Претходни резултат"
                    class="btn btn-default"
                    @click="onPreviousClick()"
                  >
                    <span class="fa fa-chevron-left"></span>
                  </button>
                </span>
                <input
                  class="search-input form-control"
                  v-model="textSearch"
                  placeholder="Претрага по приказаном тексту"
                  type="text"
                />
                <span class="input-group-btn right-search">
                  <button
                    tooltips=""
                    tooltip-append-to-body="true"
                    tooltip-side="bottom"
                    tooltip-class="tooltip-klass"
                    title="Следећи резултат"
                    class="btn btn-default"
                    @click="onNextClick()"
                  >
                    <span class="fa fa-chevron-right"></span>
                  </button>
                </span>
              </div>
            </div>
            <div
              id="actContentPrimaryScroll"
              class="view-act-primary card card-1 full-height"
              style="overflow-y: auto; position: absolute; top: 35px;"
            >
              <HtmlDiv
                id="primaryContentHtml"
                v-if="contentPrimary"
                v-html="contentPrimary"
                width="100%"
                height="800px"
                showChanges="true"
              >
              </HtmlDiv>
            </div>
            <div class="preview-ref">
              <div class="right-panel">
                <div class="panel-group" id="accordion" v-if="act != null">
                  <div
                    v-if="
                      filteredReferences !== null &&
                        filteredReferences.length > 0
                    "
                    class="panel panel-default"
                    id="panelReferences"
                  >
                    <div
                      data-toggle="collapse"
                      data-target="#collapseReferences"
                      class="panel-heading"
                    >
                      <h5 class="panel-title">
                        <a>
                          Референце
                        </a>
                      </h5>
                    </div>
                    <div
                      id="collapseReferences"
                      class="panel-collapse collapse"
                    >
                      <ul
                        class="panel-body list-group"
                        style="padding: 0px!important;"
                      >
                        <div
                          v-for="key in filteredReferences"
                          :key="key"
                          class="reference-list"
                        >
                          <h5>
                            <span class="fa fa-plus-square"></span>
                            {{ references[key].actReferenceTypeName }}
                          </h5>
                          <ul>
                            <li
                              v-for="act in references[key].lawActs"
                              :key="act.url"
                            >
                              <a
                                v-if="act.inlineUrl === null"
                                :href="act.url"
                                target="_blank"
                                >{{ act.name }}</a
                              >
                              <a v-else @click="openInlineUrl(act.inlineUrl)">{{
                                act.name
                              }}</a>
                            </li>
                          </ul>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-2 col-md-2 right-panel hidden-xs hidden-sm">
            <div class="panel-group" id="accordion" v-if="act != null">
              <div
                v-if="
                  filteredReferences !== null && filteredReferences.length > 0
                "
                class="panel panel-default"
                id="panelReferences"
              >
                <div
                  data-toggle="collapse"
                  data-target="#collapseReferences"
                  class="panel-heading"
                >
                  <h5 class="panel-title">
                    <a>
                      Референце
                    </a>
                  </h5>
                </div>
                <div id="collapseReferences" class="panel-collapse collapse">
                  <ul
                    class="panel-body list-group"
                    style="padding: 0px!important;"
                  >
                    <div
                      v-for="key in filteredReferences"
                      :key="key"
                      class="reference-list"
                    >
                      <h5>
                        <span class="fa fa-plus-square"></span>
                        {{ references[key].actReferenceTypeName }}
                      </h5>
                      <ul>
                        <li
                          v-for="act in references[key].lawActs"
                          :key="act.url"
                        >
                          <a
                            v-if="act.inlineUrl === null"
                            :href="act.url"
                            target="_blank"
                            >{{ act.name }}</a
                          >
                          <a v-else @click="openInlineUrl(act.inlineUrl)">{{
                            act.name
                          }}</a>
                        </li>
                      </ul>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
window.$ = window.jQuery = require("jquery");
import axios from "axios";
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/js/bootstrap.min.js";
import "jquery-highlight/jquery.highlight.js";
import HtmlDiv from "@/components/HtmlDiv.vue";
//import { changeImageSrc } from "../../utils/helper-methods";
import { mapActions } from "vuex";


export default {
  name: "SLGLRS_ViewActPage",
  props: ["renderData"],
  data() {
    return {
      baseApiUrl: window.env.VUE_APP_API_SLGL_DEV,
      meta: {
        title: "Правно-информациони систем РС",
        description:
          "Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.",
        keywords:
          "zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik",
      },
      act: null,
      references: null,
      contentPrimary: null,
      showPdf: false,
      scrollIndex: 0,
      textSearch: "",
      eliLink: "",
      hasEli: "",
      metadataLinks: [],
      lawActId: null,
      actTitle: "",
      metadataKeys: [
        "name",
        "about",
        "property",
        "resource",
        "content",
        "dataType",
        "typeOf",
      ],
      //property koji se postavlja an true ukoliko dolazimo sa eliWrapper komponente (da se ne bi pozivale akcije duplo)
      redirected: false,
    };
  },
  watch: {
    textSearch(newValue) {
      window
        .$("#actContentPrimaryScroll")
        .unhighlight({ className: "pronadjen" });
      if (newValue !== null && newValue.length > 0) {
        window
          .$("#actContentPrimaryScroll")
          .highlight(newValue, { className: "pronadjen" });
      }
      this.scrollIndex = 0;
    },
  },
  computed: {
    filteredReferences() {
      return this.references !== null
        ? Object.keys(this.references).filter(
            (key) => this.references[key] !== null
          )
        : [];
    },
  },
  metaInfo() {
    const actTitle = this.actTitle;
    var filteredMetadata = this.metadataLinks.map((x) => {
      var arr = Object.entries(x);
      return Object.fromEntries(arr.filter((el) => el[1] !== null));
    });
    return {
      title: actTitle,
      meta: [
        { name: "google", content: "notranslate" },
        {
          name: "viewport",
          content:
            "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no",
        },
        { name: "robots", content: "index,nofollow,noarchive" },
        ...filteredMetadata,
      ],
    };
  },
  methods: {
    ...mapActions(["setShowLayout"]),

    onPrintClick(text) {
      axios
        .get(
          this.baseApiUrl +
            "Prins/viewdoc?uuid=" +
            this.act.contentUrl +
            "&actId=" +
            this.act.id.toString() +
            "&doctype=slgl"
        )
        .then((response) => {
          var tab = window.open("", "_blank");
          var numberDetails =
            '<p style="font-family: Verdana, Arial, sans-serif; font-size: 10px; margin-bottom: 20px;">' +
            text +
            "</p>";
          tab.document.write(numberDetails + response.data); // where 'html' is a variable containing your HTML
          tab.document.close();
          setTimeout(() => {
            tab.print();
            tab.close();
          }, 100);
        });
    },
    showRefDiv() {
      window.$(".preview-ref").toggleClass("visible");
    },
    async onExportAct() {
      const lawActId = this.lawActId;
      const lawActName = this.act.actTitle;

      try {
        this.$loader.show();

        const response = await axios.get(
          this.baseApiUrl +
            "prins/GeneratePrimaryWordDocument?lawActId=" +
            lawActId,
          { responseType: "blob" }
        );

        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = lawActName + ".docx";
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error(error);
      } finally {
        this.$loader.hide();
      }
    },
    onExportHtml() {
      window.open(
        this.baseApiUrl +
          "Prins/viewdoc?uuid=" +
          this.act.contentUrl +
          "&actId=" +
          this.act.id.toString() +
          "&doctype=slgl",
        "_blank"
      );
    },
    onPreviousClick() {
      var items = window.$("#actContentPrimaryScroll").find(".pronadjen");
      if (items && items.length > 0) {
        this.scrollIndex--;
        if (this.scrollIndex < 0) {
          this.scrollIndex = items.length;
        }
        if (items.length > 0) {
          items[this.scrollIndex].scrollIntoView();
        }
      }
    },
    onNextClick() {
      var items = window.$("#actContentPrimaryScroll").find(".pronadjen");
      if (items && items.length > 0) {
        this.scrollIndex++;
        if (this.scrollIndex > items.length) {
          this.scrollIndex = 0;
        }
        items[this.scrollIndex].scrollIntoView();
      }
    },
    getMetadata(id) {
      axios
        .get(this.baseApiUrl + "prins/GetEliMetadata?lawAdActId=" + id)
        .then((response) => {
          this.metadataLinks = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },

    viewActMethod() {
      axios
        .get(this.baseApiUrl + "prins/viewAct/" + this.lawActId)
        .then((response) => {
          this.contentPrimary = response.data;
          this.$nextTick(() => {
            const styleTags = document
              .getElementById("primaryContentHtml")
              .querySelectorAll("style");
            styleTags.forEach((styleTag) => {
              styleTag.innerHTML = "#primaryContentHtml" + styleTag.innerHTML;
              styleTag.innerHTML = styleTag.innerHTML.replace(
                /}/g,
                "} #primaryContentHtml"
              );
            });
            window.$("#primaryContentHtml").on("click auxclick", function(e) {
              if (
                e.target.nodeName === "A" ||
                e.target.parentElement.nodeName === "A"
              ) {
                if (e.target.nodeName === "A") {
                  if (e.target.href.includes("/viewdoc"))
                    e.target.href = e.target.href.substr(
                      e.target.href.indexOf("/viewdoc")
                    );
                }
              }
            });
          });
        })
        .catch((error) => {
          console.log(error);
          this.contentPrimary = "Документ не може бити приказан.";
        });
    },
  },
  beforeCreate: function() {
    document.body.className = "color_arhslgl view-act-page";
  },
  async mounted() {
    //prvo se proverava da li se radi o internim aktima ili ne
    if (this.$route.query.internal === "true") {
      this.hasEli = false;
      this.lawActId = this.$route.params.actId;
      axios
        .get(
          this.baseApiUrl +
            "Prins/GetLawAdActViewById?id=" +
            this.$route.params.actId
        )
        .then((response) => {
          this.act = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (this.$route.params.actId) {
      //ukoliko dolazimo iz pretrage, na osnovu id-a pribavljamo eli
      this.lawActId = this.$route.params.actId;
      await axios
        .get(
          this.baseApiUrl +
            "prins/" +
            "GetEliInfoById?id=" +
            this.$route.params.actId
        )
        .then((response) => {
          const { hasEli, eliLink, lawAdActId } = response.data;
          if (hasEli) {
            this.eliLink = eliLink;
            this.hasEli = hasEli;
            const parts = eliLink.split("/");

            this.$router.push({
              name: "EliWrapperComponent",
              params: {
                level: parts[1],
                issueType: parts[2],
                authority: parts[3],
                docType: parts[4],
                gazetteYear: parts[5],
                gazetteNumber: parts[6],
                number: parts[7],
                formatOrServiceOrTimestamp1: parts[8],
              },
            });
            this.redirected = true;
          } else {
            this.lawActId = lawAdActId;
            axios
              .get(
                this.baseApiUrl +
                  "Prins/GetLawAdActViewById?id=" +
                  this.$route.params.actId
              )
              .then((response) => {
                this.act = response.data;
              })
              .catch((error) => {
                console.log(error);
              });
          }
        })
        .catch((error) => {
          if (error.response.status === 403 || error.response.status === 401)
            window.location.href = "/";
        });
    } else this.hasEli = true;
    var self = this;
    document.body.style.display = "inline";
    if (!this.redirected) {
      if (this.hasEli) {
        //ako postoji eliLink, znaci da smo eli link dobili preko GetEliInfoById akcije (pristupili smo iz neke pretrage)
        //ako ne postoji onda smo eli link dobili preko eliWrapper komponente (direktno smo pristupili linku)
        if (this.eliLink) {
          var sgAction = this.eliLink;
          await axios
            .get(self.baseApiUrl + "prins/" + sgAction)
            .then((response) => {
              this.act = response.data;
            })
            .catch((error) => {
              if (
                error.response.status !== 403 &&
                error.response.status === 401
              ) {
                document.write(error.response.data);
              } else window.location.href = "/";
            });
        } else this.act = this.renderData;

        this.lawActId = this.act.id;
        this.actTitle = this.act.actTitle;

        //provera da li akt sadrzi html ili samo pdf
        if (this.act.contentUrl !== null) {
          document.body.style.overflow = "auto";
          if (this.act.pdfBytes) {
            var binaryString = window.atob(this.act.pdfBytes);
            var binaryLength = binaryString.length;
            var bytes = new Uint8Array(binaryLength);
            for (var i = 0; i < binaryLength; i++) {
              var ascii = binaryString.charCodeAt(i);
              bytes[i] = ascii;
            }
            var blob = new Blob([bytes], { type: "application/pdf" });
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            var fileName = this.act.actTitle;
            link.download = fileName;
            link.click();
          }
          this.act.contentUrl !== undefined && this.viewActMethod();
        } else {
          this.setShowLayout(false);
          document.body.style.display = "none";
          axios
            .get(this.baseApiUrl + "Prins/GetPdfById?id=" + this.act.numberId, {
              responseType: "blob",
            })
            .then((response) => {
              document.body.style.display = "block";
              this.showPdf = true;
              document.body.style.overflow = "hidden";
              const file = new Blob([response.data], {
                type: "application/pdf",
              });
              const fileurl = URL.createObjectURL(file);
              this.contentPrimary = fileurl;
            })
            .catch(() => {
              document.write("Ne postoji akt sa URI-jem " + sgAction);
            });
        }
      } else this.viewActMethod();

      self.lawActId &&
        (await axios
          .get(
            self.baseApiUrl +
              "Prins/GetGlobalActReferencesByLawAdActId?lawActId=" +
              self.lawActId
          )
          .then((res) => {
            self.references = res.data;
            this.$nextTick(() => {
              var referenceHeaders = document.querySelectorAll(
                ".reference-list h5"
              );
              referenceHeaders.forEach(function(header) {
                header.addEventListener("click", function() {
                  var parent = this.parentNode;
                  parent.classList.toggle("expanded");
                  var spans = parent.querySelectorAll("span");
                  spans.forEach(function(span) {
                    if (parent.classList.contains("expanded")) {
                      span.classList.remove("fa-plus-square");
                      span.classList.add("fa-minus-square");
                    } else {
                      span.classList.remove("fa-minus-square");
                      span.classList.add("fa-plus-square");
                    }
                  });
                });
              });
              var dropdownToggles = document.querySelectorAll(
                ".dropdown .dropdown-toggle"
              );
              dropdownToggles.forEach(function(toggle) {
                toggle.addEventListener("click", function() {
                  var parent = this.parentNode;
                  var hasClass = parent.classList.contains("open");
                  var allDropdowns = document.querySelectorAll(".dropdown");
                  allDropdowns.forEach(function(dropdown) {
                    dropdown.classList.remove("open");
                  });
                  if (!hasClass) {
                    parent.classList.toggle("open");
                  }
                });
              });
            });
          })
          .catch((error) => {
            if (error.response.status === 403 || error.response.status === 401)
              window.location.href = "/";
          }));

      self.lawActId && (await self.getMetadata(self.lawActId));
    }
  },
  components: { HtmlDiv },
};
</script>
<style scoped>
@import "~@fortawesome/fontawesome-free/css/all.css";

.container-slgl {
  padding-left: 15px;
  padding-right: 15px;
  width: 100% !important;
  height: 100% !important;
  overflow: hidden !important;
}

@media (max-width: 1200px) {
  .container-slgl {
    overflow: unset !important;
  }
}

.highlighted {
  background: #ff0;
}

.row {
  margin-right: 0px !important;
  margin-left: 0px !important;
}

.view-act-primary {
  width: 100%;
}

@media (max-width: 990px) {
  #actContentPrimaryScroll {
    margin-bottom: 40px;
  }
}

#actTitleNavbar {
  width: 100% !important;
  display: block !important;
  padding: 0;
}

#actTitleNavbar #actTitle {
  padding: 10px !important;
  font-size: 20px !important;
}

.top-line__item a:hover {
  text-decoration: none !important;
}

/* section.base-header-sec {
  height: 0 !important;
}

.base-header__top-line.laen {
  display: none !important;
} */

.theme-green.main-panel {
  display: block;
  margin-top: 8px;
}

@media (min-width: 1200px) {
  .col-lg-offset-2 {
    margin-left: 16.66666667%;
  }
}

#actContentPrimaryScroll {
  height: 655px !important;
  top: 41px !important;
  border-top: 2px solid #cccccc;
}

.flex-div {
  display: flex;
}

.p-left {
  padding-left: 15px;
}

.theme-green .panel-heading,
#actTitle {
  background: linear-gradient(to bottom, #409edc 0%, #388bc2 100%) !important;
  padding: 10px 15px;
}

.panel.panel-default:not(:first-child) {
  margin: 5px 0 0 0;
}

.panel-title.panel-title {
  margin: 0;
}

.panel-heading {
  border-radius: 4px 4px 0 0;
}

#searchBarPrimary,
.secondary-frame-parent {
  padding: 2px;
}

#searchBarPrimary .left-search .btn-default,
.secondary-frame-parent .left-search .btn-default {
  background-color: #fff;
  box-shadow: none;
  border-radius: 0;
  border-right: 1px solid #ccc !important;
  border-top: 1px solid #ccc !important;
  border-bottom: 1px solid #ccc !important;
  height: 38px;
}

.left-search .btn-default:hover,
.right-search .btn-default:hover,
#searchBarPrimary .btn-default:hover {
  color: #333;
  background-color: #e6e6e6 !important;
  border-color: #adadad !important;
}

#searchBarPrimary .left-search,
.secondary-frame-parent .left-search {
  border: none;
}

#searchBarPrimary .left-search .btn-default:first-child,
.secondary-frame-parent .left-search .btn-default:first-child {
  border-radius: 4px 0 0 4px;
  border: 1px solid #ccc !important;
}

#searchBarPrimary .left-search .btn-default:last-child,
.secondary-frame-parent .left-search .btn-default:last-child {
  border-right: none !important;
  background-color: #fff;
}

.color_reg .site-header .navbar-pis .nav-link:before,
.color_reg .base-header__top-line {
  background: linear-gradient(103deg, #e14356 0%, white 100%) !important;
}

#searchBarPrimary .right-search,
.secondary-frame-parent .right-search {
  border-left: none !important;
  border-right: none !important;
}

#searchBarPrimary .right-search .btn-default,
.secondary-frame-parent .right-search .btn-default {
  border-left: none;
  border-radius: 0 4px 4px 0 !important;
  background-color: #fff;
  height: 36px;
}

.secondary-frame-parent .input-group-btn.previous-solo-btn .btn-default {
  background-color: #fff !important;
  height: 36px !important;
  box-shadow: none !important;
}

.secondary-frame-parent .input-group-btn.previous-solo-btn {
  border-right: none !important;
  border-left: none !important;
}

.secondary-frame-parent .input-group-btn.left-search {
  border-top: none !important;
}

#actContentPrimaryScroll {
  height: calc(100vh - 245px) !important;
  background-color: #fff;
  border-top: 3px solid #ddd !important;
  padding: 16px !important;
}

.panel.panel-default ul {
  list-style: none;
}

/* .panel.panel-default ul li {
  font-size: 12px;
} */

.panel.panel-default ul a:hover {
  text-decoration: underline !important;
}

.panel.panel-default h5 {
  /* font-size: 75%; */
  cursor: pointer;
}

.panel.panel-default {
  background-color: #fff !important;
  border-radius: 0 0 4px 4px;
  border: 1px solid #ddd !important;
}

.reference-list ul {
  display: none;
  padding-left: 15px;
}
.reference-list h5 {
  font-size: 75%;
}

.reference-list ul li {
  padding-bottom: 6px;
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 2px;
  padding-left: 6px;
  line-height: 90%;
}
.reference-list.expanded ul {
  display: block;
}

.panel-collapse.collapse {
  max-height: 450px;
  overflow: auto;
}

.main iframe {
  height: 100vh;
  z-index: 9999999999;
  position: absolute;
}

.main {
  padding-bottom: 0 !important;
}

.panel.panel-default {
  border: none !important;
}

.panel.panel-default .panel-heading {
  border-radius: 0 !important;
}

#actTitle {
  text-align: center;
}

.reference-list a {
  cursor: pointer;
  color: #333333 !important;
  font-size: 70%;
}

@media (max-width: 991px) {
  .flex-div.p-left {
    padding-left: 0;
  }
}

@media (min-width: 992px) {
  .expand-tabs-sm {
    display: none;
  }

  .preview-ref.visible {
    display: none !important;
  }
}

.preview-ref {
  display: none;
  position: absolute;
  padding: 25px;
  top: -8px;
  left: 0;
  height: 76vh;
  width: 100%;
  background-color: #efefef;

  &.visible {
    display: block;
  }
}

#searchBarPrimary input.form-control::placeholder,
.secondary-frame-parent input.form-control::placeholder {
  color: #a69999 !important;
  font-size: 100% !important;
}

#searchBarPrimary input.form-control,
.secondary-frame-parent input.form-control {
  font-size: 88% !important;
  height: 38px;
}
</style>
